/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LoginErrorCode {
    SUCCESS = 'Success',
    UNKNOWN_ERROR = 'UnknownError',
    ACCESS_NOT_ALLOWED = 'AccessNotAllowed',
    ACCOUNT_DISABLED = 'AccountDisabled',
    INVALID_CRED = 'InvalidCred',
}
